/**
 * @description Component to be used together with te SlideOutNav
 * It will render the SlideOutNav menu button using React.createPortal
 */

import React from 'react';

export const menuButtonId = 'SlideOutNavButtonPortal';
export const MenuButton = () => <div className={menuButtonId} />;
